// extracted by mini-css-extract-plugin
module.exports = {"main":"Column_main__1QMpi","heading":"Column_heading__1d8eW","wrapper":"Column_wrapper__8nYgd","container":"Column_container__RZaSb","isDragging":"Column_isDragging__2wnMh"};